import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class ClienteContatoService {
  private apiUrl = environment.apiGestorUrlLocal;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': this.tokenService.getToken(), 'session': this.tokenService.getSessionUsuario() }),
    params: {}
  };

  constructor(private tokenService: TokenService, private http: HttpClient) { }

  getListagemContatos(params, filtros): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/clienteContato/list`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  createClienteContato(payload): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/clienteContato`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getClienteContatoById(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/clienteContato/${id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }
  /* DROPDOWNS */
  getDropDownClienteContato(filtro): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/clienteContato/dropdownlist`, filtro, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }
  
  getContatoCliente(cliente_id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/clienteContato/padrao/${cliente_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getListaContatoPadrao(cliente_id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/clienteContato/lista/padrao/${cliente_id}`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getDropdownContatosCliente(filtros): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/clienteContato/dropdownlist`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  delete(id): Observable<any> {
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/clienteContato/${id}`,  this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  removeBlacklist(id): Observable<any> {    
    this.httpOptions.params = "";
    return this.http.delete(`${this.apiUrl}api/email-blacklist/${id}`,  this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  update(payload): Observable<any> {    
    this.httpOptions.params = "";
    return this.http.put(`${this.apiUrl}api/clienteContato`, payload, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  dropDownCodigoDdiPais(): Observable<any> {
    this.httpOptions.params = "";
    return this.http.get(`${this.apiUrl}api/codigo-pais/dropdown`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  dropDownSolicitantes(filtro, params): Observable<any> {
    this.httpOptions.params = params;
    return this.http.post(`${this.apiUrl}api/b2c/dropdown-solicitantes`, filtro, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  dropDownContatosB2c(filtros): Observable<any> {
    this.httpOptions.params = "";
    return this.http.post(`${this.apiUrl}api/b2c/dropdown-contatos`, filtros, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  dropDownAppsContatos(): Observable<any> {
    this.httpOptions.params = null;
    return this.http.get(`${this.apiUrl}api/clienteContato/dropdown-apps`, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(
        `Backend retornou o código ${error.status}, ` +
        `o body é:`, error);
    }
    return throwError(
      error.error);
  }
}
